import { useTranslation } from 'react-i18next';
import Text from '../../components/Text/Text';
import useCart from '../Cart/useCart';

function ProductsCount() {
  const { t } = useTranslation();
  const { products } = useCart();

  return (
    <Text type="secondary">{`${products.length} ${t('product', { count: products.length })}`}</Text>
  );
}

export default ProductsCount;
